import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';

const CollapsibleParameter = styled(Collapse)(({ theme }) => ({
  '&:not(:last-of-type)': {
    '& .MuiCollapse-wrapperInner': {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(5),
    },
  },
}));

export default CollapsibleParameter;
